<template>
  <!-- 根组件 -->
  <div id="app" ref="app">
    <!-- <Globalheader title="" url="/jdtrademark" name="首页" /> -->
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
    </router-view>
</keep-alive>

<router-view v-if="!$route.meta.keepAlive">
    <!-- 这里是不被缓存的视图组件，比如 page3 -->
</router-view>
    <!-- <Globalfooter /> -->
    <!-- <QilianFooter /> -->
  </div>
</template>
<script>
// import Globalheader from "@/components/globalheader";
// import Globalfooter from "@/components/globalfooter";
import QilianFooter from "@/components/qilianFooter";
export default {
  components: {
    // Globalheader,
    // Globalfooter,
    QilianFooter
  }
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  outline: none;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
  font-size: 14px;
}
#app {
  width: 100%;
  height: 100%;
}
.v-modal {
  z-index: 1999 !important;
}
</style>
